import "./App.css";
import { Popup } from "./components";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#3054A1",
      // light: will be calculated from palette.primary.main,
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: "#FF5F00",
      // light: "#CFA616",
      // dark: will be calculated from palette.secondary.main,
      // contrastText: will be calculated to contrast with palette.secondary.main
    },
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
});

const theme = createTheme(defaultTheme, {
  palette: {
    // augmentColor is a step that Material-UI automatically does for the standard palette colors.
    ochre: defaultTheme.palette.augmentColor({
      color: { main: "#CFA616" },
      name: "ochre",
    }),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Popup />
    </ThemeProvider>
  );
}

export default App;
